<template>

    <CCard>

        <CCardHeader>
            Настройки цены доставки
            <RestaurantTableOrderBadge />
        </CCardHeader>

        <CCardBody>
            
            <slot name="tabs"></slot>

            <CTabs
                variant="pills"
                :active-tab="0"
            >
                <CTab title="Базовая стоимость" class="pt-1">
                    <DeliveryAddress
                        :data="delivery.address"
                        :address-discount="delivery.addressDiscount"
                        @update-address="updateAddress"
                    />
                    <CButton
                        color="primary"
                        class="mt-3 mr-3"
                        @click="saveAddress"
                    >Сохранить</CButton>
                </CTab>

                <CTab title="Наценки" class="pt-1">
                    <DeliveryPrice
                        :data="delivery.price"
                        @update-price="updatePrice"
                    />
                    <CButton
                        color="primary"
                        class="mt-3 mr-3"
                        @click="savePrice"
                    >Сохранить</CButton>
                </CTab>
                
                <CTab title="Фиксированная стоимость до башни" class="pt-1">
                    <DeliveryTowerFixPrice
                        :entityType="entityType"
                        :entityId="entityId"
                        :addresses="formattedAddresses"
                        :deliveries="deliveryTypes"
                        :settings="towerFixPriceData"
                        @reload="fetch"
                    />
                </CTab>
                
                <CTab title="Ограничение доставки по башням" class="pt-1">
                    <DeliveryTowerOnlyHere
                        :entityType="entityType"
                        :entityId="entityId"
                        :addresses="formattedAddresses"
                        :deliveries="deliveryTypes"
                        :settings="deliveryOnlyHereData"
                        @reload="fetch"
                    />
                </CTab>
            </CTabs>

        </CCardBody>

        <!-- <CCardFooter>
            <CButton
                color="primary"
                class="mr-3"
                @click="save"
            >Сохранить все</CButton>
        </CCardFooter> -->

        <CElementCover
            v-if="isPending"
            :opacity="0.8"
        >
            <div class="flex items-center">
                <CSpinner size="sm" />
                <p class="ml-2 text-xl">Сохранение... </p>
            </div>
        </CElementCover>
            
    </CCard>

</template>

<script>
    import { DELIVERY_TYPE } from '@/utils/order';

    import DeliveryPrice from '@/components/delivery/DeliveryPrice';
    import DeliveryAddress from '@/components/delivery/DeliveryAddress';
    import DeliveryAddressDiscount from '@/components/delivery/DeliveryAddressDiscount';
    import DeliveryTowerFixPrice from '@/components/delivery/DeliveryTowerFixPrice';
    import DeliveryTowerOnlyHere from '@/components/delivery/DeliveryTowerOnlyHere';

    export default {

        name: 'Delivery',

        components: {
            DeliveryPrice,
            DeliveryAddress,
            DeliveryAddressDiscount,
            DeliveryTowerFixPrice,
            DeliveryTowerOnlyHere
        },

        props: {
            entityType: {
                type: String,
                default: ''
            },
            entityId: {
                type: Number,
                default: null
            },
        },
  
        data () {
            return {
                delivery: {
                    id: null,
                    entity_type: '',
                    entity_id: '',
                    priority: '',
                    address: [],
                    price: []
                },

                isPending: false,

                addresses: [],
                settings: [],

                priceData: [],
                addressData: [],
                addressDiscountData: [],
            }
        },
        computed: {
            deliveryTypes() {
                return [
                    {
                        label: 'До двери',
                        value: DELIVERY_TYPE.DOOR
                    },
                    {
                        label: 'До точки встречи',
                        value: DELIVERY_TYPE.MEETING_POINT
                    },
                    {
                        label: 'Без доставки',
                        value: DELIVERY_TYPE.WITHOUT
                    },
                    {
                        label: 'Сборка заказа',
                        value: DELIVERY_TYPE.COLLECT
                    },
                ];
            },
            formattedAddresses() {
                return this.addresses.map(item => ({
                    label: item.name,
                    value: item.id,
                }));
            },
            towerFixPriceData() {
                return this.settings ? this.settings.filter(item => item.type === 'tower_fix_price') : [];
            },
            deliveryOnlyHereData() {
                return this.settings ? this.settings.filter(item => item.type === 'delivery_only_here') : [];
            }
        },
    
        async mounted() {
            this.addresses = (await this.axios.get('/address')).data;
            await this.fetch();
        },
        
        methods: {
            async fetch() {
                this.settings = (await this.axios.get(`/entity-delivery-settings/${this.entityType}${this.entityId ? '/' + this.entityId : ''}`)).data;
                const delivery = await this.axios.get(`/delivery/${this.entityType}/${this.entityId}`);
                if (delivery?.data?.id) {
                    this.delivery = delivery.data;
                    this.delivery.address = this.delivery.address.map(item => {
                        return { 
                            ...item, 
                            free: !!item.free
                        };
                    });
                }
            },

            // async save() {
            //     this.isPending = true;

            //     try {
            //         if(this.priceData.find(item => item.demand_id === null)) {
            //             this.$root.$emit('showError', 'Для некоторых надбавок за стоимость не выбран спрос');
            //             this.isPending = false;
            //             return;
            //         }
            //         if(!this.delivery?.id || this.delivery?.entity_id !== this.entityId) {
            //             await this.axios.post(`/delivery/${this.entityType}/${this.entityId}`);
            //         }
            //         await this.savePrice();
            //         await this.saveAddress();
            //         await this.fetch();
            //     } catch (error) {
            //         this.$root.$emit('showError', 'Не удалось сохранить настройки доставки: ' + error);
            //     }

            //     this.isPending = false;
            // },

            async updatePrice(data) {
                this.priceData = data;
            },

            async savePrice() {
                this.isPending = true;
                await this.axios.post(`/delivery/${this.entityType}/${this.entityId}/price`, { price: this.priceData });
                await this.fetch();
                this.isPending = false;
            },

            async updateAddress(data) {
                this.addressData = data;
            },

            async saveAddress() {
                this.isPending = true;
                await this.axios.post(`/delivery/${this.entityType}/${this.entityId}/address`, { address: this.addressData });
                await this.fetch();
                this.isPending = false;
            },
        }
    }
</script>
